import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ zoom, onClose, onNav }) => {
  if (!zoom) return null;
  const { images, index, caption } = zoom;
  const many = images.length > 1;
  const navBtn =
    "absolute top-1/2 z-20 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition hover:bg-white/25";
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`Увеличена снимка: ${caption}`}
      data-testid="photo-lightbox"
      data-lenis-prevent
      className="fixed inset-0 z-[80] flex items-center justify-center p-4"
    >
      <button
        type="button"
        aria-label="Затвори увеличената снимка"
        data-testid="lightbox-overlay"
        onClick={onClose}
        className="absolute inset-0 cursor-default bg-black/85 backdrop-blur-sm"
      />
      <figure className="relative z-10 flex max-h-full w-full max-w-4xl flex-col items-center">
        <img
          src={images[index]}
          alt={caption}
          data-testid="lightbox-image"
          className="max-h-[80vh] w-auto max-w-full rounded-xl object-contain shadow-2xl"
        />
        <figcaption className="mt-4 text-center text-sm font-light text-white/85">
          {caption}
          {many ? ` · ${index + 1} / ${images.length}` : ""}
        </figcaption>
      </figure>
      {many && (
        <>
          <button
            type="button"
            aria-label="Предишна снимка"
            data-testid="lightbox-prev"
            onClick={() => onNav(-1)}
            className={`${navBtn} left-4`}
          >
            <ChevronLeft className="h-5 w-5" aria-hidden="true" />
          </button>
          <button
            type="button"
            aria-label="Следваща снимка"
            data-testid="lightbox-next"
            onClick={() => onNav(1)}
            className={`${navBtn} right-4`}
          >
            <ChevronRight className="h-5 w-5" aria-hidden="true" />
          </button>
        </>
      )}
      <button
        type="button"
        aria-label="Затвори"
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute right-4 top-4 z-20 inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition hover:bg-white/25"
      >
        <X className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>
  );
};
